module.exports = __webpack_public_path__ + "img/person.cacb1c2a.png";